import { ICellRendererParams } from "ag-grid-community";
import { useDispatch } from "react-redux";
import {
    setIsSearchTermExact,
    updateCustomModal,
    updateCustomModalTitle,
    updateKeywordModalType,
    updateSearchTermCampaigns,
} from "@features/modalSlice";
import { compact, map } from "underscore";

const CampaignAnchorCellRenderer = (params: ICellRendererParams) => {
    const campaigns = compact(
        map(params.data.campaign_map?.split(","), (item) => +item)
    );
    const dispatch = useDispatch();
    const modalClickHandler = () => {
        dispatch(updateCustomModal(true));
        dispatch(updateKeywordModalType("campaigns-modal"));
        dispatch(setIsSearchTermExact(params.data.is_exact));
        dispatch(updateCustomModalTitle(params.data.keyword_name));
        dispatch(updateSearchTermCampaigns(campaigns));
    };

    return (
        <>
            {params.node.rowPinned ? null : (
                <div className="anchor-class" onClick={modalClickHandler}>
                    {campaigns.length || 0}
                </div>
            )}
        </>
    );
};

export default CampaignAnchorCellRenderer;
